
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparFlag as ObiBuoySparFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-flag.js';
 
 
 

 
 export const ObiBuoySparFlag = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-flag',
   elementClass: ObiBuoySparFlagElement,
   events: {
     
   }
  });
 
 